import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RegisterMappingUpdated } from "routes/asset-register/plugins/asset-mapping/register-mapping-updated"
import { uniqueId } from "library/database/split-id.mjs"
import { globalMappingStatus } from "routes/asset-register/plugins/asset-mapping/global-mapping-status"

export function useIsAnythingBeingMapped() {
    const { register } = useBoundContext()
    RegisterMappingUpdated(uniqueId(register?._id)).useRefresh()
    if (!register) return false
    return !!globalMappingStatus[uniqueId(register._id)]?.length
}
